'use client';

export { Providers as default, Providers } from '@/root/Providers';
